export default __webpack_public_path__ + "static/media/michelle steel.58f96e32.jpg";